export default __webpack_public_path__ + "static/media/Rectangle 77.2e9afaef.png";